import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../components/useTableScrollcesar";

const CatalogoDependencias = (props) => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtDependencia = useRef([]);
  const txtBuscar = useRef();
  const [activate, setActivate] = useState(false);
  const [listaDependencias, setListaDependencias] = useState([]);
  const [dependenciasTodos, setDependenciasTodos] = useState([]);
  let values = {
    iddependencia: "",
    nombre: "",
    tipoente: "",
  };
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    { label: "CODIGO", textAlign: "center" },
    { label: "NOMBRE", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);
  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = dependenciasTodos;
    } else {
      lista = dependenciasTodos.filter((x) => {
        if (
          x.iddependencia.toString().includes(target.value) ||
          x.nombre.toLowerCase().includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setListaDependencias(lista);
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "dependencias";
    let orden = "iddependencia desc";
    let nomid = "tipoente";
    let id = props.ente.idtipoente;
    let endpoint = `${op.conexion}/api/consulta/modeliorder?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            console.log(response.data);
            setListaDependencias(response.data);
            setDependenciasTodos(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setListaDependencias([]);
    setDependenciasTodos([]);
    values = {
      iddependencia: "",
      nombre: "",
      tipoente: "",
    };
  };

  const seleccionarFila = (item, index) => {
    values = {
      iddependencia: item.iddependencia,
      nombre: item.nombre,
      tipoente: item.tipoente,
    };

    for (let i = 0; i < txtDependencia.current.length; i++) {
      if (i === index) {
        txtDependencia.current[i].style.backgroundColor = "lightskyblue";
      } else {
        if (txtDependencia.current[i]) {
          txtDependencia.current[i].style.backgroundColor = "white";
        }
      }
    }

    btnAcepta.current.focus();
  };

  const cancelar = () => {
    blanquear();
    props.onHide("cancelar", {});
  };

  const seleccionarDependencia = () => {
    props.onHide("aceptar", values);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Dependencia</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer
            container={{
              height: 200,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />

            <TableBody>
              {listaDependencias &&
                listaDependencias.map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtDependencia.current[index] = el)}
                    style={{ backgroundColor: "white" }}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.iddependencia}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombre}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          {/*           <TblPagination /> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarDependencia}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoDependencias;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoDependencias.js